
import React from 'react';
import ArauclinHomePage from './pages/ArauclinHomePage';

// Importar os estilos CSS
import './styles/global.css';
import './styles/components.css';
import './styles/pages.css';

function App() {
  return (
    <div className="App">
      <ArauclinHomePage />
    </div>
  );
}

export default App;